export default __webpack_public_path__ + "6fb895b0d5b00d48df04ed60f37135a6.webp";